import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // 修正导入路径以确保正确导入
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const app = createApp(App)
app.use(router)
app.mount('#app')
app.use(ElementPlus)
